<main class="min-h-screen flex bg-[#F8FAFC] font-sans text-slate-900">

    @if (!identity()) {
    <div class="m-auto w-full max-w-md p-6">
        <div class="text-center mb-8">
            <div class="inline-flex items-center justify-center w-16 h-16 bg-white border border-slate-200 rounded-2xl shadow-sm mb-4">
                <img src="logo.svg" class="h-10 w-10" alt="Logo">
            </div>
            <h1 class="text-3xl font-extrabold tracking-tight text-slate-900">Emparejar tablet</h1>
            <p class="text-sm text-slate-500 mt-2">Introduce el código generado desde Ajustes &gt; Tablets y un nombre para identificar esta pantalla</p>
        </div>

        <form [formGroup]="pairForm" (submit)="pair()"
            class="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm flex flex-col gap-5">

            <div class="flex flex-col gap-1.5">
                <label class="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Código de emparejamiento</label>
                <input formControlName="code" type="text" autocapitalize="characters"
                    class="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all uppercase tracking-widest text-center text-lg font-semibold"
                    placeholder="AB12CD">
            </div>

            <div class="flex flex-col gap-1.5">
                <label class="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Nombre de esta tablet</label>
                <input formControlName="name" type="text"
                    class="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all text-sm"
                    placeholder="Mostrador">
            </div>

            <button type="submit" [disabled]="pairing()"
                class="cursor-pointer w-full py-3 px-4 bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white font-semibold rounded-lg shadow-sm transition-all active:scale-[0.98] mt-2">
                {{ pairing() ? 'Emparejando…' : 'Emparejar' }}
            </button>
        </form>
    </div>
    }

    @else if (pendingDocument(); as doc) {
    <div class="m-auto w-full max-w-lg p-6 text-center">
        <div class="bg-white border border-slate-200 p-10 rounded-2xl shadow-sm flex flex-col items-center gap-6">
            <div class="w-16 h-16 rounded-full bg-indigo-50 flex items-center justify-center text-3xl">✍️</div>
            <div>
                <h1 class="text-2xl font-extrabold tracking-tight text-slate-900">Documento listo para firmar</h1>
                <p class="text-sm text-slate-500 mt-2">
                    Albarán #{{ doc.id_by_company }}
                    @if (doc.client_name) { — {{ doc.client_name }} }
                </p>
            </div>
            <button (click)="goToSign()"
                class="cursor-pointer w-full py-4 px-4 bg-indigo-600 hover:bg-indigo-700 text-white text-lg font-semibold rounded-lg shadow-sm transition-all active:scale-[0.98]">
                Firmar ahora
            </button>
        </div>
    </div>
    }

    @else {
    <div class="m-auto w-full max-w-md p-6 text-center">
        <div class="inline-flex items-center justify-center w-16 h-16 bg-white border border-slate-200 rounded-2xl shadow-sm mb-4">
            <img src="logo.svg" class="h-10 w-10 animate-pulse" alt="Logo">
        </div>
        <h1 class="text-2xl font-extrabold tracking-tight text-slate-900">Tablet «{{ identity()!.name }}»</h1>
        <p class="text-sm text-slate-500 mt-2">Esperando documentos para firmar…</p>
    </div>
    }

</main>
